const customTableTemplatesReducer = (state = {}, action) => {
    switch(action.type) {
        case 'SET_CUSTOM_TABLE_TEMPLATES':
            state = action.payload;
            return state;
        default:
            return state;
    }
}

export default customTableTemplatesReducer;